import { DESKTOP_BRIDGE_KEY, type DesktopBridge } from '@aibi/contracts';

const isDesktopBridge = (value: unknown): value is DesktopBridge =>
  typeof value === 'object' &&
  value !== null &&
  (value as { isDesktop?: unknown }).isDesktop === true;

/** Devuelve la API del preload de Electron si la web se ejecuta dentro del escritorio. */
export function getDesktopBridge(target: object = window): DesktopBridge | null {
  const candidate: unknown = Reflect.get(target, DESKTOP_BRIDGE_KEY);
  return isDesktopBridge(candidate) ? candidate : null;
}
